(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6VBea", function(module, exports) {
$parcel$export(module.exports, "b64_decode", function () { return (parcelRequire("hDdJN")).b64_decode; });
$parcel$export(module.exports, "getAllCookies", function () { return (parcelRequire("fnNvV")).getAllCookies; });
$parcel$export(module.exports, "elementReady", function () { return (parcelRequire("7YAJ4")).elementReady; });
$parcel$export(module.exports, "addWindowResizeEvent", function () { return (parcelRequire("2pyvk")).addWindowResizeEvent; });
$parcel$export(module.exports, "addWindowScrollEvent", function () { return (parcelRequire("2pyvk")).addWindowScrollEvent; });
$parcel$export(module.exports, "getReCAPTCHAResponse", function () { return (parcelRequire("9uiPq")).getReCAPTCHAResponse; });
$parcel$export(module.exports, "slideDown", function () { return (parcelRequire("cPDzI")).slideDown; });
$parcel$export(module.exports, "slideUp", function () { return (parcelRequire("cPDzI")).slideUp; });
$parcel$export(module.exports, "scrollToElement", function () { return (parcelRequire("9vUSI")).scrollToElement; });
$parcel$export(module.exports, "getThemeData", function () { return (parcelRequire("4XCT3")).getThemeData; });
$parcel$export(module.exports, "waitForElement", function () { return (parcelRequire("5BaYK")).waitForElement; });
parcelRequire("hDdJN");
parcelRequire("fnNvV");
parcelRequire("7YAJ4");
parcelRequire("2pyvk");
parcelRequire("9uiPq");
parcelRequire("cPDzI");
parcelRequire("9vUSI");
parcelRequire("4XCT3");
parcelRequire("5BaYK");

});
parcelRegister("hDdJN", function(module, exports) {

$parcel$export(module.exports, "b64_decode", function () { return $cd60bc3867d72b58$export$bf9d481ba07b53f9; });
var $cd60bc3867d72b58$export$3c2a198a9c1ae5f3 = function(string) {
    return window.btoa(unescape(encodeURIComponent(string)));
};
var $cd60bc3867d72b58$export$bf9d481ba07b53f9 = function(string) {
    return decodeURIComponent(escape(window.atob(string)));
};

});

parcelRegister("fnNvV", function(module, exports) {

$parcel$export(module.exports, "getAllCookies", function () { return $b32f6972fc6e67b5$export$1191989ae3ee4c15; });
var $b32f6972fc6e67b5$export$1191989ae3ee4c15 = function() {
    var cookies = document.cookie.split('; ');
    var allCookies = [];
    cookies.forEach(function(cookie) {
        var cookieParts = cookie.split('=');
        allCookies[cookieParts[0]] = cookieParts[1];
    });
    return allCookies;
};

});

parcelRegister("7YAJ4", function(module, exports) {

$parcel$export(module.exports, "elementReady", function () { return $5cea9fff8806cfad$export$5a68694636710d38; });
var $5cea9fff8806cfad$export$5a68694636710d38 = function(selector) {
    return new Promise(function(resolve) {
        var el = document.querySelectorAll(selector);
        if (el.length) {
            resolve(el);
            return;
        }
        new MutationObserver(function() {
            // Query for elements matching the specified selector
            Array.from(document.querySelectorAll(selector)).forEach(function(element) {
                resolve(element);
            });
        }).observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    });
};

});

parcelRegister("2pyvk", function(module, exports) {

$parcel$export(module.exports, "addWindowResizeEvent", function () { return $1c18ae62fb4dbf93$export$5f2cd73bfe4df536; });
$parcel$export(module.exports, "addWindowScrollEvent", function () { return $1c18ae62fb4dbf93$export$b502183889628ce0; });
var $1c18ae62fb4dbf93$export$5f2cd73bfe4df536 = function(callback) {
    var timeout;
    window.addEventListener('resize', function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};
var $1c18ae62fb4dbf93$export$b502183889628ce0 = function(callback) {
    var timeout;
    window.addEventListener('scroll', function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};

});

parcelRegister("9uiPq", function(module, exports) {

$parcel$export(module.exports, "getReCAPTCHAResponse", function () { return $6e85854efd3089cd$export$26ae508a4c7ca84d; });

var $dxEC4 = parcelRequire("dxEC4");

var $gh3Df = parcelRequire("gh3Df");

var $4XCT3 = parcelRequire("4XCT3");
var $6e85854efd3089cd$export$26ae508a4c7ca84d = function(action) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var _themeData_ajax_actions, themeData, e;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $4XCT3.getThemeData)()
                    ];
                case 1:
                    themeData = _state.sent();
                    if (!themeData.recaptcha_site_key) throw new Error('Missing Google reCAPTCHA Site Key in theme configuration');
                    if (!((_themeData_ajax_actions = themeData.ajax_actions) === null || _themeData_ajax_actions === void 0 ? void 0 : _themeData_ajax_actions.recaptcha_verify)) throw new Error('Missing AJAX route to verify reCAPTCHA token');
                    if (!themeData.ajax_route) throw new Error('Missing global AJAX route');
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            if (window.grecaptcha === undefined) {
                                console.warn('Google reCAPTCHA is not loaded');
                                resolve({
                                    success: true,
                                    score: 1
                                });
                            } else window.grecaptcha.ready(function() {
                                window.grecaptcha.execute(themeData.recaptcha_site_key, {
                                    action: action
                                }).then(function(token) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                        var formData, testParam, url, response, json, errorMessages, e;
                                        return (0, $gh3Df._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    formData = new FormData();
                                                    formData.append('action', themeData.ajax_actions.recaptcha_verify);
                                                    // Determine if request is just a test
                                                    testParam = 'e2e-test';
                                                    url = new URL(window.location);
                                                    if (url.searchParams.has(testParam)) token = 'e2e-test-valid-user';
                                                    // Set reCAPTCHA token
                                                    formData.append('recaptcha_token', token);
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        4,
                                                        ,
                                                        5
                                                    ]);
                                                    return [
                                                        4,
                                                        fetch(themeData.ajax_route, {
                                                            method: 'POST',
                                                            body: formData
                                                        })
                                                    ];
                                                case 2:
                                                    response = _state.sent();
                                                    return [
                                                        4,
                                                        response.json()
                                                    ];
                                                case 3:
                                                    json = _state.sent();
                                                    if (json.success) resolve(json);
                                                    else if (json['error-codes']) {
                                                        /**
								 * reCAPTCHA verification error codes
								 * @link https://developers.google.com/recaptcha/docs/verify#error_code_reference
								 *
								 * missing-input-secret	  The secret parameter is missing.
								 * invalid-input-secret	  The secret parameter is invalid or malformed.
								 * missing-input-response	The response parameter is missing.
								 * invalid-input-response	The response parameter is invalid or malformed.
								 * bad-request	          The request is invalid or malformed.
								 * timeout-or-duplicate	  The response is no longer valid: either is too old or has been used previously.
								 */ errorMessages = [];
                                                        json['error-codes'].forEach(function(errorCode) {
                                                            switch(errorCode){
                                                                case 'missing-input-secret':
                                                                    errorMessages.push('The secret parameter is missing.');
                                                                    break;
                                                                case 'invalid-input-secret':
                                                                    errorMessages.push('The secret parameter is invalid or malformed.');
                                                                    break;
                                                                case 'missing-input-response':
                                                                    errorMessages.push('The response parameter is missing.');
                                                                    break;
                                                                case 'invalid-input-response':
                                                                    errorMessages.push('The response parameter is invalid or malformed.');
                                                                    break;
                                                                case 'bad-request':
                                                                    errorMessages.push('The request is invalid or malformed.');
                                                                    break;
                                                                case 'timeout-or-duplicate':
                                                                    errorMessages.push('The response is no longer valid: either is too old or has been used previously.');
                                                                    break;
                                                                default:
                                                                    errorMessages.push('Unknown reCAPTCHA error code');
                                                            }
                                                        });
                                                        throw new Error("There was an error when trying to verify the user's response by reCAPTCHA:\n".concat(errorMessages.join('\n')));
                                                    } else if (json.data) throw new Error("The request to verify the reCAPTCHA user token failed: ".concat(response.data));
                                                    else throw new Error('Unknown error occurred when trying to verify the reCAPTCHA user token');
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 4:
                                                    e = _state.sent();
                                                    reject(e);
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 5:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                });
                            });
                        })
                    ];
                case 2:
                    e = _state.sent();
                    console.error(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};

});
parcelRegister("dxEC4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dbddc5847e39269$export$71511d61b312f219; });
function $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dbddc5847e39269$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("gh3Df", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd910d1ee9896911$export$71511d61b312f219; });
function $bd910d1ee9896911$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("4XCT3", function(module, exports) {

$parcel$export(module.exports, "getThemeData", function () { return $39cad640efa60b84$export$3c72f11fd9e5031f; });
var $39cad640efa60b84$export$3c72f11fd9e5031f = function() {
    if (!window.themeDataRestUrl) throw new Error('Missing themeDataRestUrl in global context');
    else {
        var sessionStorageKey = 'themeData';
        return new Promise(function(resolve, reject) {
            if (sessionStorage.getItem('themeData')) resolve(JSON.parse(sessionStorage.getItem(sessionStorageKey)));
            else fetch(window.themeDataRestUrl).then(function(res) {
                return res.json();
            }).then(function(data) {
                try {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
                } catch (e) {
                    console.warn(e);
                }
                resolve(data);
            }).catch(function(e) {
                return reject(e);
            });
        });
    }
};

});


parcelRegister("cPDzI", function(module, exports) {

$parcel$export(module.exports, "slideUp", function () { return $9578f243206a91ae$export$deed561b1a0ff1ea; });
$parcel$export(module.exports, "slideDown", function () { return $9578f243206a91ae$export$abdd11a06a163232; });
var $9578f243206a91ae$export$deed561b1a0ff1ea = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, isSearchable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return new Promise(function(resolve) {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        [
            'height',
            'paddingTop',
            'paddingBottom',
            'marginTop',
            'marginBottom'
        ].forEach(function(prop) {
            target.style[prop] = 0;
        });
        window.setTimeout(function() {
            if (!isSearchable) target.style.display = 'none';
            [
                'height',
                'padding-top',
                'padding-bottom',
                'margin-top',
                'margin-bottom',
                'overflow',
                'transition-duration',
                'transition-property'
            ].forEach(function(prop) {
                return target.style.removeProperty(prop);
            });
            resolve();
        }, duration);
    });
};
var $9578f243206a91ae$export$abdd11a06a163232 = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, isSearchable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return new Promise(function(resolve) {
        if (!isSearchable) {
            target.style.removeProperty('display');
            var display = window.getComputedStyle(target).display;
            if (display === 'none') display = 'block';
            target.style.display = display;
        }
        var height = target.offsetHeight;
        target.style.overflow = 'hidden';
        [
            'height',
            'paddingTop',
            'paddingBottom',
            'marginTop',
            'marginBottom'
        ].forEach(function(prop) {
            target.style[prop] = 0;
        });
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        [
            'padding-top',
            'padding-bottom',
            'margin-top',
            'margin-bottom'
        ].forEach(function(prop) {
            return target.style.removeProperty(prop);
        });
        window.setTimeout(function() {
            [
                'height',
                'overflow',
                'transition-duration',
                'transition-property'
            ].forEach(function(prop) {
                return target.style.removeProperty(prop);
            });
            resolve();
        }, duration);
    });
};
var $9578f243206a91ae$export$715de50cedc228a8 = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
    return window.getComputedStyle(target).display === 'none' ? $9578f243206a91ae$export$abdd11a06a163232(target, duration) : $9578f243206a91ae$export$deed561b1a0ff1ea(target, duration);
};

});

parcelRegister("9vUSI", function(module, exports) {

$parcel$export(module.exports, "scrollToElement", function () { return $6ed321ce261ae421$export$2353115f31f4d15; });
var $6ed321ce261ae421$export$2353115f31f4d15 = function(selector) {
    var targetEl = document.querySelector(selector);
    if (!targetEl) return;
    window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top);
};

});

parcelRegister("5BaYK", function(module, exports) {

$parcel$export(module.exports, "waitForElement", function () { return $4138ec9fb36217c9$export$1a1c301579a08d1e; });
var $4138ec9fb36217c9$export$1a1c301579a08d1e = function(selector) {
    return new Promise(function(resolve) {
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        var observer = new MutationObserver(function() {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

});


parcelRequire("6VBea");
var $2pyvk = parcelRequire("2pyvk");
var $2d0ae21580b2880d$export$a6d18b072e3b7ccb = {
    firstLevelListItems: function() {
        return document.querySelectorAll('header.nav li.lvl--1:has(ul)');
    },
    firstLevelSubmenuListItems: function() {
        return document.querySelectorAll('header.nav nav.left li.lvl--1:has(nav.sub--menu)');
    },
    levelTriggerButtons: function() {
        return document.querySelectorAll('header.nav button:has(+ ul)');
    },
    nav: function() {
        return document.querySelector('header.nav');
    },
    navContainer: function() {
        return document.querySelector('header.nav .container');
    },
    openLevelListItem: function() {
        return document.querySelector('header.nav li.lvl--1.lvl--open:has(> ul)');
    },
    openSubMenuListItem: function() {
        return document.querySelector('header.nav li.lvl--1.lvl--open:has(> nav)');
    },
    searchListItem: function() {
        return document.querySelector('header.nav li.lvl--search');
    },
    subMenuTriggerButtons: function() {
        return document.querySelectorAll('header.nav button:has(+ nav)');
    }
};
var $2d0ae21580b2880d$export$598bfe93f68ad7b5 = {
    levelOpen: 'lvl--open',
    firstLevel: 'lvl--1',
    navBg: 'nav--bg',
    navOnHighlight: 'nav--on-highlight'
};
var $2d0ae21580b2880d$export$5fdfd40a67be54d = 1200;


var $e5c1a8bbc728715a$var$setLeftSubNavOffset = function() {
    var containerWidth = (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).navContainer().getBoundingClientRect().width;
    (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).firstLevelSubmenuListItems().forEach(function(listItem) {
        var submenu = listItem.querySelector('nav.sub--menu');
        // Temporarily reveal the submenu to measure it correctly when the `hidden` attribute is set.
        var wasHidden = submenu.hasAttribute('hidden');
        if (wasHidden) submenu.removeAttribute('hidden');
        var submenuWidth = submenu.getBoundingClientRect().width;
        if (wasHidden) submenu.setAttribute('hidden', '');
        // If the subnav is smaller than the container, align it to the 1st level nav menu item
        if (submenuWidth < containerWidth) {
            var offset = listItem.offsetLeft + listItem.getBoundingClientRect().width / 2;
            var targetPositionLeft = offset - submenuWidth / 2;
            var targetPositionRight = offset + submenuWidth / 2;
            var containerLeftEdge = (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).navContainer().offsetLeft;
            var containerRightEdge = (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).navContainer().offsetLeft + containerWidth;
            if (targetPositionLeft >= containerLeftEdge && targetPositionRight <= containerRightEdge) submenu.style.setProperty('--subnav-offset-left', "".concat(offset, "px"));
            else if (targetPositionLeft < containerLeftEdge) submenu.style.setProperty('--subnav-offset-left', "".concat(containerLeftEdge + submenuWidth / 2, "px"));
            else if (targetPositionRight > containerRightEdge) submenu.style.setProperty('--subnav-offset-left', "".concat(containerRightEdge - submenuWidth / 2, "px"));
        }
    });
};
var $e5c1a8bbc728715a$var$setTopSubNavOffset = function() {
    if ((0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav()) {
        var headerNavRect = (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav().getBoundingClientRect();
        var offsetTop = headerNavRect.top + headerNavRect.height;
        (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav().style.setProperty('--subnav-offset-top', "".concat(offsetTop, "px"));
    }
};
var $e5c1a8bbc728715a$var$resizeObserver = new ResizeObserver(function(entries) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (entry.contentRect.width >= (0, $2d0ae21580b2880d$export$5fdfd40a67be54d)) {
                $e5c1a8bbc728715a$var$setLeftSubNavOffset();
                $e5c1a8bbc728715a$var$setTopSubNavOffset();
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$e5c1a8bbc728715a$var$resizeObserver.observe(document.body);
(0, $2pyvk.addWindowScrollEvent)($e5c1a8bbc728715a$var$setTopSubNavOffset);



var $f0a16191f466065a$var$navIsOnHighlight = function() {
    return (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav().classList.contains((0, $2d0ae21580b2880d$export$598bfe93f68ad7b5).navOnHighlight);
};
var $f0a16191f466065a$var$setHighlightColorScheme = function() {
    (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav().setAttribute('data-color-scheme', 'highlight');
};
var $f0a16191f466065a$var$removeHighlightColorScheme = function() {
    if ((0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav().hasAttribute('data-color-scheme')) (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav().removeAttribute('data-color-scheme');
};
var $f0a16191f466065a$export$d9afcbe2ff9d9ea3 = function() {
    // Adds a class to differ between nav and background
    if (window.scrollY > 0 || (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).openSubMenuListItem() || window.innerWidth < (0, $2d0ae21580b2880d$export$5fdfd40a67be54d)) {
        (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav().classList.add((0, $2d0ae21580b2880d$export$598bfe93f68ad7b5).navBg);
        $f0a16191f466065a$var$removeHighlightColorScheme();
    } else {
        (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav().classList.remove((0, $2d0ae21580b2880d$export$598bfe93f68ad7b5).navBg);
        if ($f0a16191f466065a$var$navIsOnHighlight()) $f0a16191f466065a$var$setHighlightColorScheme();
    }
};



var $6b1a5c9d302cf2c4$var$onWindowClick = function(e) {
    var openSubMenuListItem = (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).openSubMenuListItem();
    if (!openSubMenuListItem) return;
    var eventPath = typeof e.composedPath === 'function' ? e.composedPath() : [];
    var clickedInsideOpenSubMenu = eventPath.includes(openSubMenuListItem) || openSubMenuListItem.contains(e.target);
    var clickedColorModeSwitch = eventPath.some(function(node) {
        return node instanceof Element && node.closest('.lvl--color-mode');
    });
    if (!clickedInsideOpenSubMenu && !clickedColorModeSwitch) {
        $6b1a5c9d302cf2c4$var$closeOpenSubMenus();
        window.removeEventListener('click', $6b1a5c9d302cf2c4$var$onWindowClick);
    }
};
var $6b1a5c9d302cf2c4$var$closeOpenSubMenus = function() {
    $6b1a5c9d302cf2c4$var$closeLevel((0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).openSubMenuListItem());
};
var $6b1a5c9d302cf2c4$var$levelIsOpen = function(listItem) {
    return listItem.classList.contains((0, $2d0ae21580b2880d$export$598bfe93f68ad7b5).levelOpen);
};
var $6b1a5c9d302cf2c4$var$setExpandedState = function(listItem, isOpen) {
    // Toggle aria-expanded on the trigger button and hidden on the related sub navigation.
    var trigger = listItem.querySelector(':scope > button');
    if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    var subNav = listItem.querySelector(':scope > nav.sub');
    if (subNav) {
        if (isOpen) subNav.removeAttribute('hidden');
        else subNav.setAttribute('hidden', '');
    }
};
var $6b1a5c9d302cf2c4$var$openSubMenu = function(listItem) {
    var _ELEMENTS_searchListItem_querySelector, _ELEMENTS_nav;
    // Prevent multiple first level nav items from being open at the same time
    $6b1a5c9d302cf2c4$var$closeOpenSubMenus();
    listItem.classList.add((0, $2d0ae21580b2880d$export$598bfe93f68ad7b5).levelOpen);
    $6b1a5c9d302cf2c4$var$setExpandedState(listItem, true);
    // Focus search input when opening submenu
    if (listItem === (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).searchListItem()) (_ELEMENTS_searchListItem_querySelector = (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).searchListItem().querySelector('input')) === null || _ELEMENTS_searchListItem_querySelector === void 0 ? void 0 : _ELEMENTS_searchListItem_querySelector.focus();
    (_ELEMENTS_nav = (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav()) === null || _ELEMENTS_nav === void 0 ? void 0 : _ELEMENTS_nav.dispatchEvent(new CustomEvent('subMenuChange'));
    // Register event listener on the window level to close submenu when clicking outside
    window.addEventListener('click', $6b1a5c9d302cf2c4$var$onWindowClick);
};
var $6b1a5c9d302cf2c4$var$openLevel = function(listItem) {
    var // Prevent multiple first level nav items from being open at the same time
    _ELEMENTS_openLevelListItem;
    (_ELEMENTS_openLevelListItem = (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).openLevelListItem()) === null || _ELEMENTS_openLevelListItem === void 0 ? void 0 : _ELEMENTS_openLevelListItem.classList.remove((0, $2d0ae21580b2880d$export$598bfe93f68ad7b5).levelOpen);
    listItem.classList.add((0, $2d0ae21580b2880d$export$598bfe93f68ad7b5).levelOpen);
};
var $6b1a5c9d302cf2c4$var$closeLevel = function(listItem) {
    var _ELEMENTS_nav;
    if (!listItem) return;
    listItem.classList.remove((0, $2d0ae21580b2880d$export$598bfe93f68ad7b5).levelOpen);
    $6b1a5c9d302cf2c4$var$setExpandedState(listItem, false);
    (_ELEMENTS_nav = (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav()) === null || _ELEMENTS_nav === void 0 ? void 0 : _ELEMENTS_nav.dispatchEvent(new CustomEvent('subMenuChange'));
};
// Open stage when button is clicked
(0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).subMenuTriggerButtons().forEach(function(button) {
    button.addEventListener('click', function() {
        var listItem = button.closest('li');
        // Open or close the level
        if ($6b1a5c9d302cf2c4$var$levelIsOpen(listItem)) $6b1a5c9d302cf2c4$var$closeLevel(listItem);
        else $6b1a5c9d302cf2c4$var$openSubMenu(listItem);
    });
});
(0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).levelTriggerButtons().forEach(function(button) {
    button.addEventListener('click', function() {
        var listItem = button.closest('li');
        // Open or close the level
        if ($6b1a5c9d302cf2c4$var$levelIsOpen(listItem)) $6b1a5c9d302cf2c4$var$closeLevel(listItem);
        else $6b1a5c9d302cf2c4$var$openLevel(listItem);
    });
});
if ((0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav()) {
    // Handle the color scheme
    [
        'scroll',
        'DOMContentLoaded',
        'resize'
    ].forEach(function(type) {
        window.addEventListener(type, (0, $f0a16191f466065a$export$d9afcbe2ff9d9ea3));
    });
    (0, $2d0ae21580b2880d$export$a6d18b072e3b7ccb).nav().addEventListener('subMenuChange', (0, $f0a16191f466065a$export$d9afcbe2ff9d9ea3));
}

})();
//# sourceMappingURL=mega_nav.min.js.map
